import { render, staticRenderFns } from "./DeleteProduct.vue?vue&type=template&id=b8381306"
import script from "./DeleteProduct.vue?vue&type=script&lang=js"
export * from "./DeleteProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports